module.exports = __webpack_public_path__ + "img/logo-fake.0381ef19.svg";